// Hand-crafted brand wordmarks for the "As seen in" strip.
// Each renders as inline styled text using fonts already loaded via index.css
// (Fraunces serif, DM Sans, and system stack). Pixel-crisp at any DPI.

// Height baseline: ~28px on desktop, ~24px on mobile.
// All colors match the publication's actual brand hue.

export const OUTLET_LOGOS = [
  {
    key: "ndtv",
    name: "NDTV",
    render: (colorful) => (
      <span
        className="inline-flex items-baseline gap-[2px] font-display"
        style={{
          fontWeight: 900,
          fontSize: "22px",
          letterSpacing: "-0.03em",
          fontStretch: "condensed",
          color: colorful ? "#d40e2b" : undefined,
        }}
      >
        <span>N</span>
        <span
          style={{
            background: colorful ? "#d40e2b" : "#8c89ad",
            color: "#fff",
            padding: "0 3px",
            borderRadius: "2px",
          }}
        >
          DTV
        </span>
      </span>
    ),
  },
  {
    key: "hindu",
    name: "The Hindu BusinessLine",
    render: (colorful) => (
      <span className="inline-flex items-baseline gap-1.5">
        <span
          className="font-display italic"
          style={{
            fontWeight: 700,
            fontSize: "20px",
            letterSpacing: "-0.01em",
            color: colorful ? "#00568D" : undefined,
          }}
        >
          The Hindu
        </span>
        <span
          style={{
            fontWeight: 800,
            fontSize: "10px",
            letterSpacing: "0.14em",
            textTransform: "uppercase",
            color: colorful ? "#c02026" : undefined,
            borderTop: `1px solid ${colorful ? "#c02026" : "currentColor"}`,
            paddingTop: "1px",
          }}
        >
          BusinessLine
        </span>
      </span>
    ),
  },
  {
    key: "mylapore",
    name: "Mylapore Times",
    render: (colorful) => (
      <span
        className="font-display"
        style={{
          fontWeight: 700,
          fontSize: "18px",
          letterSpacing: "-0.01em",
          color: colorful ? "#154d38" : undefined,
        }}
      >
        Mylapore <span style={{ fontStyle: "italic" }}>Times</span>
      </span>
    ),
  },
  {
    key: "yocee",
    name: "YoCee",
    render: (colorful) => (
      <span
        style={{
          fontWeight: 900,
          fontSize: "22px",
          letterSpacing: "-0.02em",
          color: colorful ? "#f39c12" : undefined,
          fontFamily: '"DM Sans", sans-serif',
        }}
      >
        Yo<span style={{ color: colorful ? "#1a1640" : "currentColor" }}>Cee</span>
      </span>
    ),
  },
  {
    key: "tms",
    name: "Tell My Story",
    render: (colorful) => (
      <span className="inline-flex items-baseline gap-1">
        <span
          style={{
            fontWeight: 800,
            fontSize: "17px",
            letterSpacing: "-0.02em",
            color: colorful ? "#e83e8c" : undefined,
            fontFamily: '"DM Sans", sans-serif',
          }}
        >
          tellmystory
        </span>
        <span
          style={{
            fontWeight: 600,
            fontSize: "12px",
            color: colorful ? "#8c89ad" : undefined,
            fontFamily: '"DM Sans", sans-serif',
          }}
        >
          .in
        </span>
      </span>
    ),
  },
  {
    key: "newsbytes",
    name: "NewsBytes",
    render: (colorful) => (
      <span
        style={{
          fontWeight: 900,
          fontSize: "19px",
          letterSpacing: "-0.02em",
          fontFamily: '"DM Sans", sans-serif',
        }}
      >
        <span style={{ color: colorful ? "#1a1640" : "currentColor" }}>news</span>
        <span style={{ color: colorful ? "#1abc9c" : "currentColor" }}>Bytes</span>
      </span>
    ),
  },
  {
    key: "linkedin",
    name: "LinkedIn",
    render: (colorful) => (
      <span
        className="inline-flex items-baseline"
        style={{
          fontWeight: 700,
          fontSize: "19px",
          letterSpacing: "-0.02em",
          color: colorful ? "#0a66c2" : undefined,
          fontFamily: '"DM Sans", sans-serif',
        }}
      >
        <span>Linked</span>
        <span
          style={{
            background: colorful ? "#0a66c2" : "#8c89ad",
            color: "#fff",
            padding: "0 5px",
            borderRadius: "3px",
            marginLeft: "1px",
          }}
        >
          in
        </span>
      </span>
    ),
  },
];
